import { defineComponent, computed } from "vue";
const _sfc_main = defineComponent({
  name: "VaCardBlock",
  props: {
    horizontal: {
      type: Boolean,
      default: false
    }
  },
  setup: (props) => ({
    classComputed: computed(() => ({
      "va-card-block--horizontal": props.horizontal
    }))
  })
});
export {
  _sfc_main as _
};

import '../../../../../VaCardBlock.css';
//# sourceMappingURL=VaCardBlock.vue_vue_type_script_lang-60f23fba.mjs.map
